import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../modules/auth/auth.service';
import { UserProfile, UserRoleTypes } from '../web-api-client';
import { WtStorageService } from '../wt-storage.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavMenuComponent implements OnInit {
  @ViewChild('notif') navbarToggler: ElementRef;
  userProfile: UserProfile;

  constructor(public authService: AuthService,public wtStorage:WtStorageService, public changeDetectRef:ChangeDetectorRef) {

  }


  ngOnInit(): void {
    this.authService.isAuthenticated$.subscribe((isAuth) => {

      if (isAuth) {

        this.userProfile = this.wtStorage.getuser();
        this.changeDetectRef.detectChanges();

      }


    });
  }
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  public isAuthenticated():boolean {
    return this.userProfile != null;
  }

  public isGlobalAdmin(): boolean {
    return this.userProfile && this.userProfile.userRole == UserRoleTypes.Global_Admin;
  }

  navBarTogglerIsVisible() {
    return this.navbarToggler.nativeElement.offsetParent !== null;
  }

  collapseNav() {
    event.stopPropagation();
    event.preventDefault();
    if (this.navBarTogglerIsVisible()) {
      const element = this.navbarToggler.nativeElement;
      element.classList.remove("show");
    }
  }
}
